import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43113874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_cell = _resolveComponent("t-cell")!
  const _component_t_empty = _resolveComponent("t-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordList, (item) => {
      return (_openBlock(), _createBlock(_component_t_cell, {
        key: item.id,
        "has-arrow": false,
        "left-title": item.award_name,
        "left-label": _ctx.dayjs(Number(item.create_time)).format('YYYY-MM-DD'),
        "right-title": item.award_info
      }, null, 8, ["left-title", "left-label", "right-title"]))
    }), 128)),
    (!_ctx.recordList.length && _ctx.isRequested)
      ? (_openBlock(), _createBlock(_component_t_empty, {
          key: 0,
          type: "fixed",
          title: _ctx.$t('暂无领取记录')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}